var e = /* @__PURE__ */ new Set(), a = null, n = (r) => (e.add(r), () => e.delete(r)), u = () => e.size > 0, s = (r) => (a = r, () => {
  a === r && (a = null);
}), o = async (r) => {
  for (const t of e) {
    const i = t(r);
    if (i instanceof Promise) {
      if (!await i) return !1;
    } else if (!i)
      return a ? a() : !1;
  }
  return !0;
};
export {
  u as hasNavigationGuards,
  n as registerNavigationGuard,
  s as registerNavigationGuardDialog,
  o as runNavigationGuards
};

//# sourceMappingURL=navigationGuard.helper.js.map